import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const LegendWrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
`;

export const LegendItem = styled.div`
	display: flex;
	align-items: center;
	padding-left: 32px;
`;

export const LegendColor = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 1px;
	background-color: ${props => props.color};
`;

export const LegendName = styled.div`
	font-size: 11px;
	color: ${colors.grey8};
	padding-left: 8px;
`;
